export const new_hampshire = {
  "33000": "New Hampshire",
  "33001": "Belknap County",
  "33003": "Carroll County",
  "33005": "Cheshire County",
  "33007": "Coos County",
  "33009": "Grafton County",
  "33011": "Hillsborough County",
  "33013": "Merrimack County",
  "33015": "Rockingham County",
  "33017": "Strafford County",
  "33019": "Sullivan County",
};
